export const baseUrl='https://el-arca-server.herokuapp.com';

// en el futuro si cambio el servidor backend debo colocar la url aquí